import axios from 'axios';
import { captureException } from '@playbookux/playbook-web-core';
import { config } from '../../config';

export const getUserTracking = async () => {
  try {
    // Limit the tracking to only production environment, we have 50k request month.
    if (config.REACT_APP_SENTRY_ENVIRONMENT !== 'production') {
      return {
        location: 'development',
        ip: '127.0.0.1',
      };
    }

    const token = config.REACT_APP_IP_INFO_KEY;
    const response = await axios.get(`https://ipinfo.io/?token=${token}`);
    return response.data;
  } catch (error) {
    captureException('USER_TRACKING_FAILURE', error?.message);
    return null;
  }
};
